export interface AdminActivityLogChangeDto {
  field?: string;
  Field?: string;
  before?: string | null;
  Before?: string | null;
  after?: string | null;
  After?: string | null;
}

export interface AdminActivityLogDto {
  id?: number;
  Id?: number;
  actorUserId?: number;
  ActorUserId?: number;
  actorUsername?: string | null;
  ActorUsername?: string | null;
  action?: string;
  Action?: string;
  entityType?: string;
  EntityType?: string;
  entityId?: number;
  EntityId?: number;
  menuId?: number | null;
  MenuId?: number | null;
  summaryTh?: string | null;
  SummaryTh?: string | null;
  changes?: AdminActivityLogChangeDto[];
  Changes?: AdminActivityLogChangeDto[];
  requestPath?: string | null;
  RequestPath?: string | null;
  ipAddress?: string | null;
  IpAddress?: string | null;
  createDate?: string | null;
  CreateDate?: string | null;
}

export interface AdminActivityLogChange {
  field: string;
  before: string | null;
  after: string | null;
}

export interface AdminActivityLog {
  id: number;
  actorUserId: number;
  actorUsername: string;
  action: string;
  entityType: string;
  entityId: number;
  menuId: number | null;
  summaryTh: string;
  changes: AdminActivityLogChange[];
  requestPath: string;
  ipAddress: string;
  createDate: string | null;
}

export interface AdminActivityLogTableQuery {
  page?: number;
  pageSize?: number;
  startDate?: string;
  endDate?: string;
  actorUserId?: number;
  entityType?: string;
  entityId?: number;
  action?: string;
  searchText?: string;
}

/** Matches API AdminActivityEntityTypes */
export const AdminActivityEntityTypes = {
  RegisterMember: 'city_parking_register_member',
  RegisterMemberGroup: 'city_parking_register_member_group',
  Vehicle: 'city_parking_vehicle',
  ParkingCard: 'parking_card',
  ParkingTransaction: 'parking_transaction',
  Invoice: 'city_parking_invoice_header',
  InvoiceDetail: 'city_parking_invoice_details',
  Finance: 'parking_finance',
  FullTaxInvoice: 'full_tax_invoice',
  TopupAccount: 'city_parking_topup_account',
  TopupTransaction: 'city_parking_topup_transaction',
  Customer: 'city_parking_customer',
  AddressInvoice: 'city_parking_address_invoice',
  LineOaMember: 'city_parking_customer_lineoa',
  CpUser: 'city_parking_user',
  Role: 'city_parking_role',
  MenuRole: 'city_parking_menu_role',
  BackofficeUser: 'res_users',
  BackofficeUserSession: 'city_parking_user_session',
  ApprovalConfig: 'city_parking_approval_config',
  ApprovalRequest: 'city_parking_approval_request',
  DiscountFreeRange: 'city_parking_discount_free_range',
  StampGroup: 'city_parking_stamp_group',
  StampAmountMap: 'city_parking_stamp_amount_map',
  StampBillableCharge: 'city_parking_stamp_billable_charge',
  ParkingSite: 'parking_site',
  ParkingClient: 'parking_client',
  ParkingVehicleType: 'parking_vehicle_type',
  ParkingCardType: 'parking_card_type',
  ParkingCardMode: 'parking_card_mode',
  ParkingGateType: 'parking_gate_type',
  ParkingGate: 'parking_gate',
  ParkingArea: 'parking_area',
  ParkingGateGroup: 'parking_gate_group',
  ParkingRate: 'parking_rate',
  ParkingMainRate: 'parking_main_rate',
  ParkingSubRate: 'parking_sub_rate',
  ParkingPenaltyRate: 'parking_penalty_rate',
  ParkingSubscription: 'parking_subscription',
  ParkingFee: 'parking_fee',
  ParkingFeeGroup: 'parking_fee_group',
  GroupMenu: 'city_parking_group_menu',
  GroupSubMenu: 'city_parking_group_sub_menu',
  MenuList: 'city_parking_menu_list',
  News: 'city_parking_news',
  NewsCategory: 'city_parking_news_category',
  InvoiceFee: 'city_parking_invoice_fee',
  InvoiceSiteConfig: 'city_parking_invoice_site_config',
  IssueType: 'city_parking_issue_type',
  ServiceCase: 'city_parking_service_case',
  PrestampTaiwan: 'prestamp_taiwan_request',
  EvPriceRate: 'city_parking_ev_price_rate',
  EvConnectorType: 'parking_ev_connector_type',
  EvChargingJob: 'city_parking_charging_jobs',
  EvTransaction: 'city_parking_transaction_ev',
  FinanceCoupon: 'parking_finance_coupon',
  CityParkingDiscount: 'city_parking_discount',
  CityParkingStampList: 'city_parking_stamp_list',
  LiffHomeMenuConfig: 'city_parking_liff_home_menu_config',
  SiteFreeQuota: 'city_parking_site_free_quota',
  ClientFreeQuota: 'city_parking_client_free_quota',
  UserSiteAccess: 'city_parking_user_site_access',
  AccessGroup: 'city_parking_access_group',
  LineGuideMenu: 'city_parking_line_guide_menu',
  PublicGuide: 'city_parking_public_guide',
  SitePublicProfile: 'city_parking_site_public_profile',
  LineBroadcast: 'city_parking_line_broadcast',
  BankAccount: 'city_parking_bank_account',
} as const;

const FIELD_LABELS: Record<string, string> = {
  description: 'รายละเอียด',
  fullTax: 'ใบกำกับภาษีเต็มรูป',
  feeTypeId: 'ประเภทการรับชำระ',
  delayed: 'เลื่อนชำระ',
  receiptNo: 'เลขที่ใบเสร็จ',
  cpInvoiceId: 'ใบแจ้งหนี้',
  registerMemberType: 'ประเภทการลงทะเบียน',
  membersCount: 'จำนวนสมาชิก',
  subScriptionId: 'แพ็กเกจ',
  memberStartDate: 'วันเริ่มสมาชิก',
  name: 'ชื่อ-นามสกุล',
  telephone: 'เบอร์โทร',
  phone: 'เบอร์โทร',
  address: 'ที่อยู่',
  cardCode: 'รหัสบัตร',
  cardName: 'ชื่อบัตร',
  issueDate: 'วันเริ่มต้น',
  expireDate: 'วันหมดอายุ',
  cardTypeId: 'ประเภทบัตร',
  subscriptionId: 'แพ็กเกจ',
  clientId: 'ลูกค้า',
  rateId: 'อัตราค่าบริการ',
  gateGroupId: 'กลุ่มประตู',
  cardMode: 'โหมดบัตร',
  uid: 'LINE UID',
  cpUserId: 'รหัสสมาชิก',
  status: 'สถานะ',
  feeId: 'ค่าธรรมเนียม',
  remarks: 'หมายเหตุ',
  remark: 'หมายเหตุ',
  deleted: 'ลบ',
  plateNumber: 'ทะเบียนรถ',
  licensePlate: 'ทะเบียนรถ',
  provinceId: 'จังหวัด',
  vehicleTypeId: 'ประเภทรถ',
  active: 'ใช้งาน',
  isDeleted: 'ลบทะเบียน',
  created: 'สร้างทะเบียน',
  paymentConfirmed: 'ยืนยันชำระเงิน',
  financeId: 'รหัสรายได้',
  exitDate: 'วันเวลาออก',
  dueDate: 'วันครบกำหนด',
  totalAmount: 'ยอดรวม',
  detailsCount: 'จำนวนรายการ',
  paymentStatus: 'สถานะชำระเงิน',
  paymentMethod: 'ช่องทางชำระ',
  verifyRejectReason: 'เหตุผลปฏิเสธ',
  lineStatus: 'สถานะรายการ',
  cancelReason: 'เหตุผลยกเลิก',
  reason: 'เหตุผล',
  statusId: 'สถานะ',
  cancelRequested: 'ขออนุมัติยกเลิก',
  approvalRequestId: 'รหัสคำขออนุมัติ',
  customerName: 'ชื่อลูกค้า',
  details: 'รายละเอียด',
  reference: 'อ้างอิง',
  taxId: 'เลขผู้เสียภาษี',
  email: 'อีเมล',
  headquarters: 'สำนักงานใหญ่',
  cpAddressId: 'ที่อยู่ใบแจ้งหนี้',
  amount: 'จำนวนเงิน',
  topupMethod: 'ประเภทปรับยอด',
  topupTransactionId: 'รหัสรายการเติมเงิน',
  enable: 'เปิดใช้งาน',
  displayName: 'ชื่อที่แสดง',
  cpRole: 'Role',
  siteIdStr: 'ลานที่เข้าถึง',
  stampAllowed: 'อนุญาตแสตมป์',
  stampRanges: 'ช่วงแสตมป์',
  stampMany: 'แสตมป์หลายรายการ',
  passwordReset: 'รีเซ็ตรหัสผ่าน',
  isActive: 'เซสชันใช้งาน',
  kickedSessions: 'จำนวนเครื่องที่เตะ',
  maxLevelCount: 'จำนวนชั้นอนุมัติ',
  menuListId: 'เมนู',
  assignedUserId: 'ผู้อนุมัติถัดไป',
  startDate: 'วันเริ่มต้น',
  endDate: 'วันสิ้นสุด',
  isEnabled: 'เปิดใช้งาน',
  fullName: 'ชื่อเต็ม',
  type: 'ประเภท',
  userStatusId: 'สถานะสมาชิก',
  alertEntry: 'แจ้งเตือนเข้า',
  alertExit: 'แจ้งเตือนออก',
  alertExpire: 'แจ้งเตือนหมดอายุ',
  viewer: 'ดูอย่างเดียว',
  approve: 'อนุมัติ',
  canCreate: 'สร้างได้',
  canEdit: 'แก้ไขได้',
  canDelete: 'ลบได้',
  canMenuRole: 'จัดการเมนู Role',
  canView: 'ดูได้',
  canAction: 'ทำรายการได้',
  roleId: 'Role',
  costType: 'ประเภทค่าใช้จ่าย',
  cpCustomerId: 'ลูกค้า',
  hasLimit: 'จำกัดโควต้า',
  limitType: 'ประเภทโควต้า',
  limitQty: 'จำนวนโควต้า',
  siteId: 'ลาน',
  parkingRateId: 'ส่วนลด',
  sequence: 'ลำดับ',
  fee: 'ค่าธรรมเนียม',
  vat: 'VAT',
  latitude: 'ละติจูด',
  longitude: 'ลองจิจูด',
  open: 'เปิดให้บริการ',
  isOnline: 'ออนไลน์',
  isFreeParking: 'จอดฟรี',
  openTime: 'เวลาเปิด',
  closeTime: 'เวลาปิด',
  key: 'รหัสลาน',
  taiwanUrl: 'Taiwan URL',
  taiwanSite: 'Taiwan Site',
  monthly: 'รายเดือน',
  parking: 'จอดรถ',
  clientTypeId: 'ประเภท Client',
  parentClientId: 'Parent Client',
  clientRole: 'บทบาท Client',
  canSelfManage: 'จัดการเองได้',
  limitTransaction: 'จำกัดธุรกรรม',
  limitCard: 'จำกัดบัตร',
  stamp: 'Stamp',
  contact: 'ผู้ติดต่อ',
  branch: 'สาขา',
  parkingTypeTaiwan: 'ประเภท Taiwan',
  member: 'สมาชิก',
  detail: 'รายละเอียด',
  posId: 'POS ID',
  ip: 'IP',
  gateTypeId: 'ประเภทประตู',
  areaId: 'พื้นที่',
  apiUser: 'API User',
  apiPass: 'API Password',
  connectDate: 'วันเชื่อมต่อ',
  monitor: 'มอนิเตอร์',
  deviceKey: 'Device Key',
  defaultRate: 'อัตราเริ่มต้น',
  prefix: 'Prefix',
  companyId: 'บริษัท',
  sapName: 'SAP Name',
  sapNameM: 'SAP Name M',
  checkCode: 'Check Code',
  evConnectorTypeId: 'ประเภทหัวชาร์จ',
  powerKw: 'กำลังไฟ (kW)',
  customerVisible: 'แสดงลูกค้า',
  staffVisible: 'แสดงเจ้าหน้าที่',
  parentGateId: 'ประตูหลัก',
  displayNames: 'ชื่อแสดงหลายภาษา',
  taiwanGate: 'Taiwan Gate',
  online: 'ออนไลน์',
  lot: 'ล็อต',
  providerId: 'ผู้ให้บริการ',
  gateIds: 'รายการประตู',
  freeTime: 'เวลาฟรี',
  taiwanDiscountId: 'Taiwan Discount',
  discount: 'ส่วนลด',
  taiwanFineId: 'Taiwan Fine',
  splitByVehicleType: 'แยกส่วนลดตามประเภทรถ',
  taiwanDiscountId2: 'Taiwan Discount (ประเภทรถ 2)',
  taiwanFineId2: 'Taiwan Fine (ประเภทรถ 2)',
  mainRateId: 'รหัสอัตราหลัก',
  rateCustomerCarId: 'อัตราลูกค้า (รถ)',
  rateCustomerBikeId: 'อัตราลูกค้า (มอเตอร์ไซค์)',
  rateTenantCarId: 'อัตราผู้เช่า (รถ)',
  rateTenantBikeId: 'อัตราผู้เช่า (มอเตอร์ไซค์)',
  minTenantAllowCar: 'นาทีอนุญาตผู้เช่า (รถ)',
  minTenantAllowBike: 'นาทีอนุญาตผู้เช่า (มอเตอร์ไซค์)',
  penaltyCarId: 'อัตราปรับ (รถ)',
  penaltyBikeId: 'อัตราปรับ (มอเตอร์ไซค์)',
  rateHolidayCarId: 'อัตรวันหยุด (รถ)',
  rateHolidayBikeId: 'อัตรวันหยุด (มอเตอร์ไซค์)',
  commentTh: 'หมายเหตุ (TH)',
  commentEn: 'หมายเหตุ (EN)',
  rateType: 'ประเภทอัตรา',
  subFreeTimeYn: 'มีเวลาฟรีย่อย',
  minFreeTime: 'นาทีฟรี',
  minRound: 'ปัดนาที',
  timePeriodFree: 'ช่วงเวลาฟรี',
  pricePerHour: 'ราคาต่อชั่วโมง',
  hourOverFlat: 'ชั่วโมงเกิน Flat',
  priceFlat: 'ราคา Flat',
  comment: 'หมายเหตุ',
  format: 'รูปแบบ',
  serviceChargeFormat: 'รูปแบบค่าบริการ',
  cutTime: 'ตัดเวลา',
  penaltyId: 'รหัสอัตราปรับ',
  overTime: 'เวลาเกิน',
  finePrice: 'ค่าปรับ',
  identify: 'รหัสระบุ',
  calculateCategory: 'หมวดคำนวณ',
  calculateType: 'ประเภทคำนวณ',
  whTax: 'หัก ณ ที่จ่าย',
  vatIncluded: 'รวม VAT',
  feeGroupId: 'กลุ่มค่าธรรมเนียม',
  imageChanged: 'รูปภาพ',
  number: 'ลำดับ',
  icon: 'ไอคอน',
  groupMenuId: 'กลุ่มเมนูหลัก',
  groupSubId: 'กลุ่มเมนูย่อย',
  pathId: 'รหัสพาธ',
  title: 'หัวข้อ',
  titleEn: 'หัวข้อ (EN)',
  summary: 'สรุป',
  body: 'เนื้อหา',
  bodyEn: 'เนื้อหา (EN)',
  coverImageUrl: 'รูปปก',
  categoryId: 'หมวด',
  visibility: 'การมองเห็น',
  pin: 'ปักหมุด',
  sortOrder: 'ลำดับแสดง',
  linkUrl: 'ลิงก์',
  linkLabel: 'ข้อความลิงก์',
  publishFrom: 'เผยแพร่ตั้งแต่',
  publishTo: 'เผยแพร่ถึง',
  showOnGlobal: 'แสดงบนหน้า Home / ข่าวรวม',
  code: 'รหัส',
  nameEn: 'ชื่อ (EN)',
  defaultInvoiceType: 'ประเภทใบแจ้งหนี้เริ่มต้น',
  enableThaiQr: 'เปิด Thai QR',
  enableBankTransfer: 'เปิดโอนธนาคาร',
  enableStaffConfirm: 'เปิดยืนยันโดยพนักงาน',
  defaultBankAccountId: 'บัญชีธนาคารเริ่มต้น',
  allowBankTransferNotify: 'แจ้งเตือนโอนธนาคาร',
  externalNotifyUrl: 'URL แจ้งเตือนภายนอก',
  defaultDueDays: 'วันครบกำหนดเริ่มต้น',
  invoiceNoPrefix: 'คำนำหน้าเลขใบแจ้งหนี้',
  category: 'หมวด',
  resolutionMode: 'โหมดแก้ไข',
  customerSelectable: 'ลูกค้าเลือกได้',
  requiresRefund: 'ต้องคืนเงิน',
  requiresApproval: 'ต้องอนุมัติ',
  defaultSlaHours: 'SLA (ชั่วโมง)',
  newStatus: 'สถานะใหม่',
  resolutionSummary: 'สรุปการแก้ไข',
  message: 'ข้อความ',
  actionType: 'ประเภทการกระทำ',
  ruleUuid: 'Rule UUID',
  quantity: 'จำนวน',
  stampLimit: 'จำกัดแสตมป์',
  requestRemark: 'หมายเหตุคำขอ',
  taiwanSyncStatus: 'สถานะซิงก์ Taiwan',
  taiwanScheduleUuid: 'Taiwan Schedule UUID',
  billingMode: 'โหมดคิดเงิน',
  unitPrice: 'ราคาต่อหน่วย',
  unitMinute: 'นาทีต่อหน่วย',
  unitKwh: 'kWh ต่อหน่วย',
  gateId: 'ประตู',
  jobStatus: 'สถานะงาน',
  chargingEnd: 'เวลาสิ้นสุดชาร์จ',
  lineUid: 'LINE UID',
  vehicleId: 'รหัสรถ',
  license: 'ทะเบียน',
  taxRequired: 'ต้องมีภาษี',
  addressType: 'ประเภทที่อยู่',
  subDistrict: 'ตำบล/แขวง',
  district: 'อำเภอ/เขต',
  provinces: 'จังหวัด',
  zipCode: 'รหัสไปรษณีย์',
  codePrefix: 'คำนำหน้าโค้ด',
  qty: 'จำนวนสร้าง',
  maxUsage: 'ใช้ได้สูงสุด',
  qtyGenerated: 'จำนวนที่สร้างแล้ว',
  stampLimitDay: 'จำกัดแสตมป์/วัน',
  stampLimitMonth: 'จำกัดแสตมป์/เดือน',
  limitDay: 'จำกัดวัน',
  limitMonth: 'จำกัดเดือน',
  stampType: 'ประเภทแสตมป์',
  quotaApproved: 'โควต้าที่อนุมัติ',
  quotaUsed: 'โควต้าที่ใช้แล้ว',
  quotaAllocatedToClients: 'โควต้าแจกให้ Client',
  quotaRemainingDirect: 'โควต้าคงเหลือ (ตรง)',
  quotaRemainingPool: 'โควต้าคงเหลือ (pool)',
  quotaRemaining: 'โควต้าคงเหลือ',
  additionalQuota: 'เพิ่มโควต้า',
  managedBy: 'ผู้ดูแลโควต้า',
  canManageQuota: 'จัดการโควต้าได้',
  canManageFreeCards: 'จัดการบัตรจอดฟรีได้',
  canDeleteCardReturnQuota: 'ลบบัตรคืนโควต้าได้',
  resUserId: 'ผู้ใช้ Backoffice',
  resUserIds: 'สมาชิกในกลุ่ม',
  clientIds: 'Client ในกลุ่ม',
  subscriptionIds: 'Subscription จอดฟรี',
  groupType: 'ประเภทกลุ่ม',
  parentSiteQuotaId: 'โควต้าลาน (parent)',
  slug: 'Slug',
  titleTh: 'หัวข้อ',
  isPublished: 'เผยแพร่',
  blockCount: 'จำนวนบล็อก',
  imagePath: 'รูปภาพ',
  imageCount: 'จำนวนรูปแกลเลอรี',
  amenities: 'สิ่งอำนวยความสะดวก',
  altText: 'ข้อความแจ้งเตือน',
  audienceType: 'กลุ่มผู้รับ',
  bubbles: 'การ์ดข้อความ',
  recipientCount: 'จำนวนผู้รับ',
  retryRecipientCount: 'จำนวนผู้รับที่ส่งซ้ำ',
  siteIds: 'กลุ่ม site',
  excludedUserIds: 'สมาชิกที่ติ๊กออก',
  messageType: 'รูปแบบข้อความ',
  images: 'รูปภาพที่ส่ง',
  imageText: 'ข้อความแนบท้ายรูป',
  newsIds: 'ประกาศที่แจ้ง',
  bankName: 'ธนาคาร',
  accountName: 'ชื่อบัญชี',
  accountNumber: 'เลขที่บัญชี',
  accountType: 'ประเภทบัญชี',
};

/** Normalize legacy paths then map body field → Thai form label. */
export function adminActivityFieldLabel(field: string): string {
  if (!field) return '—';

  const normalized = field
    .replace(/^parkingVehicle(?=\[|\.|$)/, 'vehicles')
    .replace(/\.deleted$/, '.isDeleted');

  const vehicleMatch = normalized.match(/^(?:vehicles)(?:\[\d*\])?\.(.+)$/);
  if (vehicleMatch) {
    const prop = vehicleMatch[1];
    return FIELD_LABELS[prop] ?? prop;
  }

  const memberMatch = normalized.match(/^members(?:\[\d*\])?\.(.+)$/);
  if (memberMatch) {
    const prop = memberMatch[1];
    return FIELD_LABELS[prop] ?? prop;
  }

  return FIELD_LABELS[normalized] ?? normalized;
}

/** Format ISO / Odoo-like datetime strings for display (dd/MM/yyyy HH:mm). */
export function adminActivityValueLabel(value: string | null | undefined): string {
  if (value == null || value === '') return '—';
  const trimmed = String(value).trim();
  if (!trimmed) return '—';

  // 2027-09-30 16:59:59 or 2027-09-30T16:59:59
  const m = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?/);
  if (m) {
    return `${m[3]}/${m[2]}/${m[1]} ${m[4]}:${m[5]}`;
  }

  const dateOnly = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (dateOnly) {
    return `${dateOnly[3]}/${dateOnly[2]}/${dateOnly[1]}`;
  }

  return trimmed;
}
